import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

import { handleAdvocatesRedirect } from './utils';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-advocates',
		path: '/p/:slug/advocates',
		beforeServerRender: handleAdvocatesRedirect,
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_advocates" */ './index'), {
			exportName: 'PsfAdvocates',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
